module.exports = __webpack_public_path__ + "img/3.f0fa7be9.jpg";